export type ProductComponent = {
  tag: 'a' | 'div'
  attrs: Partial<Record<'href', string>>
}

export const enum ProductType {
  simple = 'simple',
  selection = 'selection',
}
